(() => {
  const clock = document.querySelector('#local-clock');

  function renderClock() {
    if (!clock) return;
    const now = new Date();
    const parts = new Intl.DateTimeFormat(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }).formatToParts(now);

    const hour = parts.find((part) => part.type === 'hour')?.value ?? '';
    const minute = parts.find((part) => part.type === 'minute')?.value ?? '';
    const period = (parts.find((part) => part.type === 'dayPeriod')?.value ?? '').toLowerCase();

    clock.textContent = `${hour}.${minute} ${period} -`;
    clock.dateTime = now.toISOString();
    clock.title = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  renderClock();
  if (clock) window.setInterval(renderClock, 1000);

  document.addEventListener('click', (event) => {
    const backLink = event.target.closest('[data-history-back]');
    if (!backLink) return;

    const referrer = document.referrer;
    const sameOriginReferrer = referrer && new URL(referrer).origin === window.location.origin;
    if (sameOriginReferrer && window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  });
})();

(() => {
  const galleries = document.querySelectorAll('[data-product-gallery]');

  galleries.forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
    const previousButton = gallery.querySelector('[data-gallery-previous]');
    const nextButton = gallery.querySelector('[data-gallery-next]');

    if (slides.length < 2) return;

    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let touchStartX = null;

    const showSlide = (requestedIndex) => {
      activeIndex = (requestedIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    };

    previousButton?.addEventListener('click', () => showSlide(activeIndex - 1));
    nextButton?.addEventListener('click', () => showSlide(activeIndex + 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number.parseInt(dot.dataset.galleryDot || '0', 10);
        showSlide(Number.isNaN(index) ? 0 : index);
      });
    });

    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(activeIndex - 1);
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(activeIndex + 1);
      }
    });

    gallery.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX ?? null;
    }, { passive: true });

    gallery.addEventListener('touchend', (event) => {
      if (touchStartX === null) return;
      const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
      const distance = touchEndX - touchStartX;
      touchStartX = null;

      if (Math.abs(distance) < 42) return;
      showSlide(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    showSlide(activeIndex);
  });
})();


(() => {
  const mobileQuery = window.matchMedia('(max-width: 700px)');
  const toggles = document.querySelectorAll('[data-mobile-menu-toggle]');

  toggles.forEach((toggle) => {
    const sidebar = toggle.closest('.shop-sidebar');
    const menuId = toggle.getAttribute('aria-controls');
    const menu = menuId ? document.getElementById(menuId) : sidebar?.querySelector('[data-mobile-shop-menu]');
    if (!sidebar || !menu) return;

    const closeMenu = () => {
      sidebar.classList.remove('is-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Ouvrir le menu');
    };

    const openMenu = () => {
      sidebar.classList.add('is-menu-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Fermer le menu');
    };

    toggle.addEventListener('click', (event) => {
      if (!mobileQuery.matches) return;
      event.preventDefault();
      sidebar.classList.contains('is-menu-open') ? closeMenu() : openMenu();
    });

    mobileQuery.addEventListener?.('change', (event) => {
      if (!event.matches) closeMenu();
    });
  });
})();


(() => {
  const initializeGallery = (gallery) => {
    if (!gallery || gallery.dataset.blogGalleryInitialized === 'true') return;

    const items = Array.from(gallery.querySelectorAll('[data-blog-gallery-item]'));
    const lightbox = gallery.querySelector('[data-blog-lightbox]');
    const image = lightbox?.querySelector('[data-blog-lightbox-image]');
    const caption = lightbox?.querySelector('[data-blog-lightbox-caption]');
    const closeButton = lightbox?.querySelector('[data-blog-lightbox-close]');
    const previousButton = lightbox?.querySelector('[data-blog-lightbox-previous]');
    const nextButton = lightbox?.querySelector('[data-blog-lightbox-next]');

    if (!lightbox || !image || items.length === 0) return;

    gallery.dataset.blogGalleryInitialized = 'true';

    let activeIndex = 0;
    let returnFocus = null;

    const render = (requestedIndex) => {
      activeIndex = (requestedIndex + items.length) % items.length;
      const item = items[activeIndex];
      image.src = item.dataset.blogLargeSrc || '';
      image.alt = item.dataset.blogAlt || '';

      if (caption) {
        caption.textContent = item.dataset.blogCaption || '';
        caption.hidden = !caption.textContent;
      }
    };

    const open = (index, trigger) => {
      returnFocus = trigger;
      render(index);
      lightbox.hidden = false;
      document.body.classList.add('blog-lightbox-open');
      closeButton?.focus();
    };

    const close = () => {
      lightbox.hidden = true;
      document.body.classList.remove('blog-lightbox-open');
      image.removeAttribute('src');
      returnFocus?.focus();
      returnFocus = null;
    };

    items.forEach((item, index) => {
      item.addEventListener('click', () => open(index, item));
    });

    previousButton?.addEventListener('click', () => render(activeIndex - 1));
    nextButton?.addEventListener('click', () => render(activeIndex + 1));
    closeButton?.addEventListener('click', close);

    if (items.length < 2) {
      previousButton?.setAttribute('hidden', '');
      nextButton?.setAttribute('hidden', '');
    }

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) close();
    });

    gallery.addEventListener('keydown', (event) => {
      if (lightbox.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        close();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        render(activeIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        render(activeIndex + 1);
      }
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-blog-gallery]').forEach(initializeGallery);
  };

  initializeAll();

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();

/* Featured Home route on the index. */
(() => {
  const HOME_HASH = '#featured-home';
  const LEGACY_HOME_HASH = '#home';

  const isIndex = () => document.body.classList.contains('template-index');

  const applyRoute = () => {
    if (!isIndex()) return;
    const showHome = window.location.hash === HOME_HASH || window.location.hash === LEGACY_HOME_HASH;
    document.body.classList.toggle('is-featured-home', showHome);

    const landing = document.getElementById('landing-route');
    const home = document.getElementById('featured-home');
    if (landing) landing.setAttribute('aria-hidden', showHome ? 'true' : 'false');
    if (home) home.setAttribute('aria-hidden', showHome ? 'false' : 'true');

    if (showHome) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  };

  const openHome = (event) => {
    const enter = event.target.closest('[data-enter-home]');
    if (!enter || !isIndex()) return;

    event.preventDefault();
    if (window.location.hash !== HOME_HASH) {
      window.history.pushState({ afRoute: 'home' }, '', HOME_HASH);
    }
    applyRoute();
  };

  document.addEventListener('click', openHome);
  window.addEventListener('hashchange', applyRoute);
  window.addEventListener('popstate', applyRoute);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyRoute, { once: true });
  } else {
    applyRoute();
  }

  document.addEventListener('shopify:section:load', applyRoute);
})();

/* Shop all desktop range-bar carousel. Mobile remains a normal vertical page. */
(() => {
  const mobileQuery = window.matchMedia('(max-width: 700px), (max-aspect-ratio: 4/5)');

  const initializeCarousel = (carousel) => {
    if (!carousel || carousel.dataset.afCarouselReady === 'true') return;

    const viewport = carousel.querySelector('[data-af-carousel-viewport]');
    const track = carousel.querySelector('[data-af-carousel-track]');
    const range = carousel.querySelector('[data-af-carousel-range]');
    const prevButton = carousel.querySelector('[data-af-carousel-prev]');
    const nextButton = carousel.querySelector('[data-af-carousel-next]');
    if (!viewport || !track || !range) return;

    carousel.dataset.afCarouselReady = 'true';
    let maxShift = 0;
    let dragging = false;
    let dragStartX = 0;
    let dragStartValue = 0;
    let dragMoved = false;
    let itemStepPx = 0;

    const updateButtons = () => {
      if (!prevButton || !nextButton) return;
      const min = Number(range.min || 0);
      const max = Number(range.max || 1000);
      const value = Number(range.value || 0);
      prevButton.disabled = mobileQuery.matches || maxShift <= 1 || value <= min + 0.5;
      nextButton.disabled = mobileQuery.matches || maxShift <= 1 || value >= max - 0.5;
    };

    const stepRangeValue = (direction) => {
      const rangeSpan = Number(range.max || 1000) - Number(range.min || 0);
      if (rangeSpan <= 0 || maxShift <= 1) return 0;
      return (itemStepPx / maxShift) * rangeSpan * direction;
    };

    const nudge = (direction) => {
      if (mobileQuery.matches || maxShift <= 1) return;
      const min = Number(range.min || 0);
      const max = Number(range.max || 1000);
      const next = Math.min(max, Math.max(min, Number(range.value || 0) + stepRangeValue(direction)));
      range.value = String(next);
      render();
    };

    const measure = () => {
      if (mobileQuery.matches) {
        track.style.transform = '';
        range.disabled = true;
        updateButtons();
        return;
      }

      track.style.transform = 'translate3d(0,0,0)';
      maxShift = Math.max(0, track.scrollWidth - viewport.clientWidth);
      const firstCard = track.querySelector('.af-shop-product-card');
      const computedTrackStyles = window.getComputedStyle(track);
      const gap = parseFloat(computedTrackStyles.columnGap || computedTrackStyles.gap || '0') || 0;
      itemStepPx = firstCard ? firstCard.getBoundingClientRect().width + gap : viewport.clientWidth * 0.5;
      range.disabled = maxShift <= 1;
      render();
    };

    const render = () => {
      if (mobileQuery.matches) {
        track.style.transform = '';
        updateButtons();
        return;
      }
      const ratio = Number(range.value) / Number(range.max || 1000);
      track.style.transform = `translate3d(${-maxShift * ratio}px, 0, 0)`;
      updateButtons();
    };

    range.addEventListener('input', render);
    prevButton?.addEventListener('click', () => nudge(-1));
    nextButton?.addEventListener('click', () => nudge(1));

    viewport.addEventListener('wheel', (event) => {
      if (mobileQuery.matches || maxShift <= 1) return;
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      event.preventDefault();
      const next = Math.min(Number(range.max), Math.max(Number(range.min), Number(range.value) + event.deltaY * 1.3));
      range.value = String(next);
      render();
    }, { passive: false });

    viewport.addEventListener('pointerdown', (event) => {
      if (mobileQuery.matches || maxShift <= 1) return;
      dragging = true;
      dragMoved = false;
      dragStartX = event.clientX;
      dragStartValue = Number(range.value);
      viewport.setPointerCapture?.(event.pointerId);
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!dragging || mobileQuery.matches || maxShift <= 1) return;
      const distance = event.clientX - dragStartX;
      if (Math.abs(distance) > 6) dragMoved = true;
      const rangeSpan = Number(range.max) - Number(range.min);
      const next = dragStartValue - (distance / maxShift) * rangeSpan;
      range.value = String(Math.min(Number(range.max), Math.max(Number(range.min), next)));
      render();
    });

    viewport.addEventListener('click', (event) => {
      const card = event.target.closest('.af-shop-product-card[href]');
      if (!card || mobileQuery.matches) return;
      if (dragMoved) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, true);

    const stopDragging = () => {
      window.setTimeout(() => { dragMoved = false; }, 0);
      dragging = false;
    };
    viewport.addEventListener('pointerup', stopDragging);
    viewport.addEventListener('pointercancel', stopDragging);

    window.addEventListener('resize', measure, { passive: true });
    mobileQuery.addEventListener?.('change', measure);
    requestAnimationFrame(measure);
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-af-product-carousel]').forEach(initializeCarousel);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();


/* Lightweight two-layer SVG fade for the desktop Home and Shop all sidebars. */
(() => {
  const desktopMedia = window.matchMedia('(min-width: 701px) and (min-aspect-ratio: 4/5)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new WeakMap();

  const loadInto = (image, source, timeoutMs = 9000) => new Promise((resolve, reject) => {
    let settled = false;
    let timeoutId;

    const cleanup = () => {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
      window.clearTimeout(timeoutId);
    };

    const finish = (callback) => {
      if (settled) return;
      settled = true;
      cleanup();
      callback();
    };

    const onLoad = async () => {
      try {
        if (typeof image.decode === 'function') await image.decode();
      } catch (_) {
        // The browser may reject decode() even though the SVG has loaded successfully.
      }
      finish(resolve);
    };

    const onError = () => finish(() => reject(new Error(`Unable to load ${source}`)));

    image.addEventListener('load', onLoad, { once: true });
    image.addEventListener('error', onError, { once: true });
    timeoutId = window.setTimeout(onError, timeoutMs);
    image.src = source;

    if (image.complete && image.naturalWidth > 0) onLoad();
  });

  const initialize = (rotator) => {
    if (!rotator || instances.has(rotator)) return;

    const layers = Array.from(rotator.querySelectorAll('.sidebar-fade__layer'));
    const sources = Array.from(rotator.querySelectorAll('[data-sidebar-fade-src]'))
      .map((item) => item.dataset.sidebarFadeSrc)
      .filter(Boolean);

    if (layers.length !== 2 || sources.length < 2) return;

    const interval = Math.max(1000, Number(rotator.dataset.sidebarFadeInterval) || 4000);
    const fadeDuration = Math.max(0, Number(rotator.dataset.sidebarFadeDuration) || 720);
    rotator.style.setProperty('--sidebar-fade-duration', `${fadeDuration}ms`);

    let activeLayer = 0;
    let currentIndex = 0;
    let nextIndex = 1;
    let nextReady = false;
    let waitingForReady = false;
    let cycleTimer = null;
    let cleanupTimer = null;
    let retryTimer = null;
    let loadGeneration = 0;
    let isIntersecting = false;
    let destroyed = false;

    const canRun = () => (
      !destroyed &&
      desktopMedia.matches &&
      !document.hidden &&
      isIntersecting
    );

    const clearTimers = () => {
      window.clearTimeout(cycleTimer);
      window.clearTimeout(cleanupTimer);
      window.clearTimeout(retryTimer);
      cycleTimer = null;
      cleanupTimer = null;
      retryTimer = null;
      waitingForReady = false;
    };

    const prepareNext = async (requestedIndex = (currentIndex + 1) % sources.length) => {
      if (!canRun()) return;

      const generation = ++loadGeneration;
      nextIndex = requestedIndex;
      nextReady = false;
      const incoming = layers[activeLayer === 0 ? 1 : 0];
      incoming.classList.remove('is-visible');

      try {
        await loadInto(incoming, sources[nextIndex]);
      } catch (_) {
        if (destroyed || generation !== loadGeneration) return;
        incoming.removeAttribute('src');
        const fallbackIndex = (nextIndex + 1) % sources.length;
        retryTimer = window.setTimeout(() => prepareNext(fallbackIndex), 350);
        return;
      }

      if (destroyed || generation !== loadGeneration) return;
      nextReady = true;
      if (waitingForReady && canRun()) beginFade();
    };

    const armCycle = (shouldPrepare = true) => {
      window.clearTimeout(cycleTimer);
      cycleTimer = null;
      if (!canRun()) return;

      if (shouldPrepare && !nextReady) prepareNext();
      cycleTimer = window.setTimeout(() => {
        if (nextReady) beginFade();
        else waitingForReady = true;
      }, interval);
    };

    const beginFade = () => {
      if (!canRun() || !nextReady) {
        waitingForReady = true;
        return;
      }

      waitingForReady = false;
      nextReady = false;
      const outgoingIndex = activeLayer;
      const incomingIndex = activeLayer === 0 ? 1 : 0;
      const outgoing = layers[outgoingIndex];
      const incoming = layers[incomingIndex];

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (!canRun()) return;

          incoming.classList.add('is-visible');
          outgoing.classList.remove('is-visible');
          activeLayer = incomingIndex;
          currentIndex = nextIndex;

          // Start the next four-second interval at the beginning of this fade.
          armCycle(false);

          const cleanupDelay = reducedMotion.matches ? 0 : fadeDuration + 80;
          cleanupTimer = window.setTimeout(() => {
            outgoing.removeAttribute('src');
            if (canRun() && !nextReady) prepareNext();
          }, cleanupDelay);
        });
      });
    };

    const observer = new IntersectionObserver((entries) => {
      isIntersecting = Boolean(entries[0]?.isIntersecting);
      clearTimers();
      loadGeneration += 1;
      nextReady = false;
      if (isIntersecting && canRun()) armCycle();
    }, { threshold: 0.01 });

    const handleStateChange = () => {
      clearTimers();
      loadGeneration += 1;
      nextReady = false;
      if (canRun()) armCycle();
    };

    const destroy = () => {
      destroyed = true;
      clearTimers();
      loadGeneration += 1;
      observer.disconnect();
      document.removeEventListener('visibilitychange', handleStateChange);
      desktopMedia.removeEventListener?.('change', handleStateChange);
      instances.delete(rotator);
    };

    observer.observe(rotator);
    document.addEventListener('visibilitychange', handleStateChange);
    desktopMedia.addEventListener?.('change', handleStateChange);
    instances.set(rotator, { destroy });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-sidebar-fade]').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-sidebar-fade]').forEach((rotator) => {
      instances.get(rotator)?.destroy();
    });
  });
})();

/* Shop all — mobile-only floating Home crest + robust two-layer color fade. */
(() => {
  const mobileMedia = window.matchMedia('(max-width: 700px), (max-aspect-ratio: 4/5)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fadeInstances = new WeakMap();
  const fabInstances = new WeakMap();

  const loadImage = (image, source, timeoutMs = 8000) => new Promise((resolve, reject) => {
    let settled = false;
    let timeoutId = 0;

    const cleanup = () => {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
      window.clearTimeout(timeoutId);
    };

    const finish = (callback) => {
      if (settled) return;
      settled = true;
      cleanup();
      callback();
    };

    const onLoad = async () => {
      try {
        if (typeof image.decode === 'function') await image.decode();
      } catch (_) {
        // A loaded SVG can still render correctly when decode() rejects.
      }
      finish(resolve);
    };

    const onError = () => finish(() => reject(new Error(`Unable to load ${source}`)));

    image.addEventListener('load', onLoad, { once: true });
    image.addEventListener('error', onError, { once: true });
    timeoutId = window.setTimeout(onError, timeoutMs);
    image.src = source;

    if (image.complete && image.naturalWidth > 0) onLoad();
  });

  const initializeFab = (fab) => {
    if (!fab || fabInstances.has(fab)) return;

    const artboard = fab.closest('.artboard--shop');
    const topCrest = artboard?.querySelector('.shop-sidebar .sidebar-crest');
    const colorFade = artboard?.querySelector('[data-mobile-shop-color-fade]');
    if (!topCrest) return;

    let frame = 0;
    let threshold = 0;
    let destroyed = false;
    let lastVisible = null;

    const measure = () => {
      const rect = topCrest.getBoundingClientRect();
      threshold = window.scrollY + rect.bottom + 12;
    };

    const render = () => {
      frame = 0;
      if (destroyed) return;
      const visible = mobileMedia.matches && window.scrollY > threshold;
      fab.classList.toggle('is-visible', visible);
      fab.setAttribute('aria-hidden', visible ? 'false' : 'true');

      if (colorFade) {
        colorFade.classList.toggle('is-visible', visible);
        colorFade.setAttribute('aria-hidden', visible ? 'false' : 'true');
        if (lastVisible !== visible) {
          colorFade.dispatchEvent(new CustomEvent('mobile-shop-visibility-change', {
            detail: { visible }
          }));
        }
      }
      lastVisible = visible;
    };

    const requestRender = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(render);
    };

    const handleResize = () => {
      measure();
      requestRender();
    };

    const destroy = () => {
      destroyed = true;
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', requestRender);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
      mobileMedia.removeEventListener?.('change', handleResize);
      fabInstances.delete(fab);
    };

    measure();
    render();
    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', handleResize, { passive: true });
    window.addEventListener('orientationchange', handleResize, { passive: true });
    mobileMedia.addEventListener?.('change', handleResize);
    fabInstances.set(fab, { destroy });
  };

  const initializeFade = (rotator) => {
    if (!rotator || fadeInstances.has(rotator)) return;

    const layers = Array.from(rotator.querySelectorAll('.mobile-shop-color-fade__layer'));
    const sources = Array.from(rotator.querySelectorAll('[data-mobile-shop-color-src]'))
      .map((node) => node.dataset.mobileShopColorSrc)
      .filter(Boolean);

    if (layers.length !== 2 || sources.length < 2) return;

    const interval = Math.max(1200, Number(rotator.dataset.mobileShopColorFadeInterval) || 4000);
    const fadeDuration = Math.max(0, Number(rotator.dataset.mobileShopColorFadeDuration) || 700);
    rotator.style.setProperty('--mobile-shop-fade-duration', `${fadeDuration}ms`);

    let activeLayer = 0;
    let currentIndex = 0;
    let preparedIndex = 1;
    let prepared = false;
    let waiting = false;
    let cycleTimer = 0;
    let cleanupTimer = 0;
    let retryTimer = 0;
    let generation = 0;
    let destroyed = false;

    const canRun = () => (
      !destroyed &&
      mobileMedia.matches &&
      !document.hidden &&
      rotator.classList.contains('is-visible')
    );

    const clearTimers = () => {
      window.clearTimeout(cycleTimer);
      window.clearTimeout(cleanupTimer);
      window.clearTimeout(retryTimer);
      cycleTimer = cleanupTimer = retryTimer = 0;
      waiting = false;
    };

    const prepare = async (requested = (currentIndex + 1) % sources.length) => {
      if (!canRun()) return;

      const localGeneration = ++generation;
      prepared = false;
      preparedIndex = requested;
      const incoming = layers[activeLayer === 0 ? 1 : 0];
      incoming.classList.remove('is-visible');

      try {
        await loadImage(incoming, sources[preparedIndex]);
      } catch (_) {
        if (destroyed || localGeneration !== generation) return;
        incoming.removeAttribute('src');
        retryTimer = window.setTimeout(
          () => prepare((preparedIndex + 1) % sources.length),
          300
        );
        return;
      }

      if (destroyed || localGeneration !== generation) return;
      // Shop all stays fixed at bottom-right; random Home placement is not used here.
      prepared = true;
      if (waiting && canRun()) fade();
    };

    const schedule = (shouldPrepare = true) => {
      window.clearTimeout(cycleTimer);
      if (!canRun()) return;
      if (shouldPrepare && !prepared) prepare();
      cycleTimer = window.setTimeout(() => {
        if (prepared) fade();
        else waiting = true;
      }, interval);
    };

    const fade = () => {
      if (!canRun() || !prepared) {
        waiting = true;
        return;
      }

      waiting = false;
      prepared = false;
      const outgoingIndex = activeLayer;
      const incomingIndex = activeLayer === 0 ? 1 : 0;
      const outgoing = layers[outgoingIndex];
      const incoming = layers[incomingIndex];

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (!canRun()) return;

          incoming.classList.add('is-visible');
          outgoing.classList.remove('is-visible');
          activeLayer = incomingIndex;
          currentIndex = preparedIndex;
          schedule(false);

          cleanupTimer = window.setTimeout(() => {
            outgoing.removeAttribute('src');
            if (canRun() && !prepared) prepare();
          }, reducedMotion.matches ? 0 : fadeDuration + 80);
        });
      });
    };

    const reset = () => {
      clearTimers();
      generation += 1;
      prepared = false;
      if (canRun()) schedule();
    };

    const handleVisibilityChange = () => reset();

    const destroy = () => {
      destroyed = true;
      reset();
      document.removeEventListener('visibilitychange', reset);
      mobileMedia.removeEventListener?.('change', reset);
      rotator.removeEventListener('mobile-shop-visibility-change', handleVisibilityChange);
      fadeInstances.delete(rotator);
    };

    document.addEventListener('visibilitychange', reset);
    mobileMedia.addEventListener?.('change', reset);
    rotator.addEventListener('mobile-shop-visibility-change', handleVisibilityChange);
    fadeInstances.set(rotator, { destroy });
    if (canRun()) schedule();
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-mobile-shop-home-fab]').forEach(initializeFab);
    root.querySelectorAll('[data-mobile-shop-color-fade]').forEach(initializeFade);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mobile-shop-home-fab]').forEach((fab) => {
      fabInstances.get(fab)?.destroy();
    });
    event.target.querySelectorAll('[data-mobile-shop-color-fade]').forEach((rotator) => {
      fadeInstances.get(rotator)?.destroy();
    });
  });
})();

/* Home — mobile-only paired background fade behind the featured products. */
(() => {
  const mobileMedia = window.matchMedia('(max-width: 700px), (max-aspect-ratio: 4/5)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new WeakMap();

  const loadImage = (image, source, timeoutMs = 8000) => new Promise((resolve, reject) => {
    let settled = false;
    let timeoutId = 0;

    const cleanup = () => {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
      window.clearTimeout(timeoutId);
    };

    const finish = (callback) => {
      if (settled) return;
      settled = true;
      cleanup();
      callback();
    };

    const onLoad = async () => {
      try {
        if (typeof image.decode === 'function') await image.decode();
      } catch (_) {
        // A loaded SVG can still paint correctly when decode() rejects.
      }
      finish(resolve);
    };

    const onError = () => finish(() => reject(new Error(`Unable to load ${source}`)));

    image.addEventListener('load', onLoad, { once: true });
    image.addEventListener('error', onError, { once: true });
    timeoutId = window.setTimeout(onError, timeoutMs);
    image.src = source;

    if (image.complete && image.naturalWidth > 0) onLoad();
  });

  const initialize = (rotator) => {
    if (!rotator || instances.has(rotator)) return;

    const layers = Array.from(rotator.querySelectorAll('.mobile-home-background-fade__layer'));
    const sources = Array.from(rotator.querySelectorAll('[data-mobile-home-background-src]'))
      .map((node) => node.dataset.mobileHomeBackgroundSrc)
      .filter(Boolean);

    if (layers.length !== 2 || sources.length < 2) return;

    const figuresFor = (layer) => ({
      left: layer.querySelector('.mobile-home-background-fade__figure--left'),
      right: layer.querySelector('.mobile-home-background-fade__figure--right')
    });

    const figures = layers.map(figuresFor);
    if (figures.some((pair) => !pair.left || !pair.right)) return;

    const interval = Math.max(2000, Number(rotator.dataset.mobileHomeBackgroundFadeInterval) || 4000);
    const fadeDuration = Math.max(0, Number(rotator.dataset.mobileHomeBackgroundFadeDuration) || 1500);
    rotator.style.setProperty('--mobile-home-background-fade-duration', `${fadeDuration}ms`);

    const randomBetween = (min, max) => min + Math.random() * (max - min);
    const clamp = (value, minimum, maximum) => Math.max(minimum, Math.min(maximum, value));
    const anchors = [
      { x: 29, y: 25 },
      { x: 71, y: 25 },
      { x: 29, y: 72 },
      { x: 71, y: 72 },
      { x: 50, y: 40 },
      { x: 50, y: 66 }
    ];

    /*
     * Keep every randomized SVG fully inside the mobile Home canvas.
     * The rendered, rotated bounding box is measured before choosing x/y,
     * so no figure can be clipped at the top or at either side.
     */
    const applyRandomPlacement = (pair) => {
      const containerRect = rotator.getBoundingClientRect();
      const shuffled = anchors
        .map((anchor) => ({ anchor, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ anchor }) => anchor);

      [pair.left, pair.right].forEach((image, index) => {
        const anchor = shuffled[index];
        let scale = randomBetween(.82, .98);
        const rotation = randomBetween(-4, 4);

        image.style.setProperty('--mobile-home-x', '50%');
        image.style.setProperty('--mobile-home-y', '50%');
        image.style.setProperty('--mobile-home-scale', scale.toFixed(3));
        image.style.setProperty('--mobile-home-rotation', `${rotation.toFixed(2)}deg`);

        // Force one layout read so getBoundingClientRect() includes scale + rotation.
        void image.offsetWidth;
        let imageRect = image.getBoundingClientRect();

        if (
          containerRect.width <= 0 ||
          containerRect.height <= 0 ||
          imageRect.width <= 0 ||
          imageRect.height <= 0
        ) {
          image.style.setProperty('--mobile-home-x', `${index === 0 ? 30 : 70}%`);
          image.style.setProperty('--mobile-home-y', `${index === 0 ? 30 : 70}%`);
          image.style.setProperty('--mobile-home-rotation', '0deg');
          return;
        }

        const safeMargin = Math.max(
          10,
          Math.min(containerRect.width, containerRect.height) * .018
        );
        const availableWidth = Math.max(1, containerRect.width - safeMargin * 2);
        const availableHeight = Math.max(1, containerRect.height - safeMargin * 2);
        const fitScale = Math.min(
          1,
          availableWidth / imageRect.width,
          availableHeight / imageRect.height
        );

        if (fitScale < 1) {
          scale = Math.max(.62, scale * fitScale);
          image.style.setProperty('--mobile-home-scale', scale.toFixed(3));
          void image.offsetWidth;
          imageRect = image.getBoundingClientRect();
        }

        const minimumX = clamp(
          ((imageRect.width / 2 + safeMargin) / containerRect.width) * 100,
          0,
          50
        );
        const maximumX = 100 - minimumX;
        const minimumY = clamp(
          ((imageRect.height / 2 + safeMargin) / containerRect.height) * 100,
          0,
          50
        );
        const maximumY = 100 - minimumY;

        const x = clamp(anchor.x + randomBetween(-5, 5), minimumX, maximumX);
        const y = clamp(anchor.y + randomBetween(-4, 4), minimumY, maximumY);

        image.style.setProperty('--mobile-home-x', `${x.toFixed(2)}%`);
        image.style.setProperty('--mobile-home-y', `${y.toFixed(2)}%`);
      });
    };

    applyRandomPlacement(figures[0]);

    let activeLayer = 0;
    let currentIndex = 2;
    let preparedIndex = 3;
    let prepared = false;
    let waiting = false;
    let cycleTimer = 0;
    let cleanupTimer = 0;
    let retryTimer = 0;
    let generation = 0;
    let destroyed = false;
    let inViewport = false;

    const isRendered = () => rotator.getClientRects().length > 0;
    const canRun = () => (
      !destroyed &&
      mobileMedia.matches &&
      !reducedMotion.matches &&
      !document.hidden &&
      inViewport &&
      isRendered()
    );

    const clearTimers = () => {
      window.clearTimeout(cycleTimer);
      window.clearTimeout(cleanupTimer);
      window.clearTimeout(retryTimer);
      cycleTimer = cleanupTimer = retryTimer = 0;
      waiting = false;
    };

    const prepare = async (requested = (currentIndex + 1) % sources.length) => {
      if (!canRun()) return;

      const localGeneration = ++generation;
      prepared = false;
      preparedIndex = requested;

      const incomingLayer = activeLayer === 0 ? 1 : 0;
      const incoming = layers[incomingLayer];
      const incomingFigures = figures[incomingLayer];
      incoming.classList.remove('is-visible');

      const leftSource = sources[preparedIndex];
      const rightSource = sources[(preparedIndex + 5) % sources.length];

      applyRandomPlacement(incomingFigures);

      try {
        await Promise.all([
          loadImage(incomingFigures.left, leftSource),
          loadImage(incomingFigures.right, rightSource)
        ]);
      } catch (_) {
        if (destroyed || localGeneration !== generation) return;
        incomingFigures.left.removeAttribute('src');
        incomingFigures.right.removeAttribute('src');
        retryTimer = window.setTimeout(
          () => prepare((preparedIndex + 1) % sources.length),
          350
        );
        return;
      }

      if (destroyed || localGeneration !== generation) return;
      prepared = true;
      if (waiting && canRun()) fade();
    };

    const schedule = (shouldPrepare = true) => {
      window.clearTimeout(cycleTimer);
      if (!canRun()) return;
      if (shouldPrepare && !prepared) prepare();
      cycleTimer = window.setTimeout(() => {
        if (prepared) fade();
        else waiting = true;
      }, interval);
    };

    const fade = () => {
      if (!canRun() || !prepared) {
        waiting = true;
        return;
      }

      waiting = false;
      prepared = false;
      const outgoingLayer = activeLayer;
      const incomingLayer = activeLayer === 0 ? 1 : 0;
      const outgoing = layers[outgoingLayer];
      const incoming = layers[incomingLayer];

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (!canRun()) return;

          incoming.classList.add('is-visible');
          outgoing.classList.remove('is-visible');
          activeLayer = incomingLayer;
          currentIndex = preparedIndex;
          schedule(false);

          cleanupTimer = window.setTimeout(() => {
            figures[outgoingLayer].left.removeAttribute('src');
            figures[outgoingLayer].right.removeAttribute('src');
            if (canRun() && !prepared) prepare();
          }, fadeDuration + 100);
        });
      });
    };

    const reset = () => {
      clearTimers();
      generation += 1;
      prepared = false;
      if (canRun()) schedule();
    };

    const observer = new IntersectionObserver((entries) => {
      inViewport = entries.some((entry) => entry.isIntersecting);
      reset();
    }, { rootMargin: '20% 0px 20% 0px', threshold: 0.01 });

    const mutationObserver = new MutationObserver(reset);

    const destroy = () => {
      destroyed = true;
      clearTimers();
      generation += 1;
      observer.disconnect();
      mutationObserver.disconnect();
      document.removeEventListener('visibilitychange', reset);
      window.removeEventListener('hashchange', reset);
      window.removeEventListener('popstate', reset);
      mobileMedia.removeEventListener?.('change', reset);
      reducedMotion.removeEventListener?.('change', reset);
      instances.delete(rotator);
    };

    observer.observe(rotator);
    mutationObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('visibilitychange', reset);
    window.addEventListener('hashchange', reset);
    window.addEventListener('popstate', reset);
    mobileMedia.addEventListener?.('change', reset);
    reducedMotion.addEventListener?.('change', reset);

    instances.set(rotator, { destroy });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-mobile-home-background-fade]').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-mobile-home-background-fade]').forEach((rotator) => {
      instances.get(rotator)?.destroy();
    });
  });
})();


/* Product mobile — visible sizes, dynamic price and Shopify variants. */
(() => {
  const normalizeSize = (value) => {
    const normalized = String(value || "")
      .trim()
      .toUpperCase()
      .replace(/\s+/g, "")
      .replace(/-/g, "");

    if (normalized === "XXL") return "2XL";
    if (normalized === "XXXL") return "3XL";
    return normalized;
  };

  const initializeMobileProduct = (root) => {
    if (!root || root.dataset.mobileProductFinalInitialized === "true") return;

    const form = root.querySelector("[data-mobile-product-form]");
    const variantsScript = root.querySelector("[data-mobile-product-variants]");
    const variantInput = root.querySelector("[data-mobile-product-variant-input]");
    const submitButton = root.querySelector("[data-mobile-product-submit]");
    const status = root.querySelector("[data-mobile-product-status]");
    const optionRow = root.querySelector("[data-mobile-product-options]");
    const priceValue = root.querySelector("[data-mobile-product-price-value]");
    const sizeButtons = Array.from(root.querySelectorAll("[data-mobile-product-size]"));

    if (!form || !variantsScript || !variantInput || !submitButton || sizeButtons.length === 0) {
      return;
    }

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent || "[]");
    } catch (error) {
      console.warn("Impossible de lire les variantes produit.", error);
      return;
    }

    root.dataset.mobileProductFinalInitialized = "true";

    const requestedOptionIndex = Number.parseInt(root.dataset.sizeOptionIndex || "0", 10);
    const sizeOptionIndex = Number.isNaN(requestedOptionIndex) ? 0 : requestedOptionIndex;
    const currency = optionRow?.dataset.currency || window.Shopify?.currency?.active || "EUR";
    const locale = document.documentElement.lang || "fr-FR";
    const productHasAvailableVariant = variants.some((variant) => Boolean(variant.available));

    const formatMoney = (cents) => {
      const numericCents = Number(cents);
      if (!Number.isFinite(numericCents)) return "";

      const value = numericCents / 100;
      const hasDecimals = Math.round(numericCents) % 100 !== 0;

      try {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency,
          minimumFractionDigits: hasDecimals ? 2 : 0,
          maximumFractionDigits: 2
        }).format(value);
      } catch (error) {
        return `${value.toFixed(hasDecimals ? 2 : 0)} ${currency}`;
      }
    };

    const variantsForSize = (sizeValue) => {
      const requestedSize = normalizeSize(sizeValue);
      return variants.filter((variant) => {
        const optionValue = Array.isArray(variant.options)
          ? variant.options[sizeOptionIndex]
          : "";
        return normalizeSize(optionValue) === requestedSize;
      });
    };

    const clearSelection = () => {
      variantInput.value = "";
      submitButton.disabled = true;
      sizeButtons.forEach((button) => {
        button.classList.remove("is-selected");
        button.setAttribute("aria-pressed", "false");
      });
    };

    sizeButtons.forEach((button) => {
      const matchingVariants = variantsForSize(button.dataset.sizeValue);
      const availableVariant = matchingVariants.find((variant) => Boolean(variant.available));
      const unavailable = matchingVariants.length === 0 || !availableVariant;

      button.disabled = unavailable;
      button.classList.toggle("is-unavailable", unavailable);
      button.setAttribute("aria-disabled", unavailable ? "true" : "false");

      button.addEventListener("click", () => {
        if (button.disabled || !availableVariant) return;

        sizeButtons.forEach((otherButton) => {
          const selected = otherButton === button;
          otherButton.classList.toggle("is-selected", selected);
          otherButton.setAttribute("aria-pressed", selected ? "true" : "false");
        });

        variantInput.value = String(availableVariant.id);
        submitButton.disabled = false;

        if (priceValue) {
          priceValue.textContent = formatMoney(availableVariant.price);
        }

        if (status) {
          status.textContent = `Taille ${button.dataset.sizeLabel || button.dataset.sizeValue} sélectionnée.`;
        }
      });
    });

    clearSelection();

    if (!productHasAvailableVariant) {
      submitButton.textContent = "SOLD OUT";
      if (status) status.textContent = "Produit épuisé.";
    }

    form.addEventListener("submit", (event) => {
      if (!variantInput.value || submitButton.disabled) {
        event.preventDefault();
        if (status) status.textContent = "Choisissez une taille disponible.";
        sizeButtons.find((button) => !button.disabled)?.focus();
      }
    });
  };

  const initializeAllMobileProducts = (scope = document) => {
    scope.querySelectorAll("[data-mobile-product]").forEach(initializeMobileProduct);
  };

  initializeAllMobileProducts();

  document.addEventListener("shopify:section:load", (event) => {
    initializeAllMobileProducts(event.target);
  });
})();

/* Product desktop — numeric size labels mapped to Shopify size variants. */
(() => {
  const desktopMedia = window.matchMedia("(min-width: 701px) and (min-aspect-ratio: 4/5)");

  const normalizeSize = (value) => {
    const normalized = String(value || "")
      .trim()
      .toUpperCase()
      .replace(/\s+/g, "")
      .replace(/-/g, "");

    if (normalized === "XXL") return "2XL";
    if (normalized === "XXXL") return "3XL";
    return normalized;
  };

  const initializeDesktopProduct = (root) => {
    if (!root || root.dataset.desktopProductInitialized === "true") return;

    const form = root.querySelector(".product-buy-form");
    const variantsScript = root.querySelector("[data-desktop-product-variants]");
    const variantInput = root.querySelector("[data-desktop-product-variant-input]");
    const submitButton = root.querySelector("[data-desktop-product-submit]");
    const status = root.querySelector("[data-desktop-product-status]");
    const priceValue = root.querySelector("[data-desktop-product-price-value]");
    const sizeButtons = Array.from(root.querySelectorAll("[data-desktop-product-size]"));

    if (!form || !variantsScript || !variantInput || !submitButton || sizeButtons.length === 0) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent || "[]");
    } catch (error) {
      console.warn("Impossible de lire les variantes produit desktop.", error);
      return;
    }

    root.dataset.desktopProductInitialized = "true";

    const requestedOptionIndex = Number.parseInt(root.dataset.sizeOptionIndex || "0", 10);
    const sizeOptionIndex = Number.isNaN(requestedOptionIndex) ? 0 : requestedOptionIndex;
    const currency = window.Shopify?.currency?.active || "EUR";
    const locale = document.documentElement.lang || "fr-FR";

    const formatMoney = (cents) => {
      const numericCents = Number(cents);
      if (!Number.isFinite(numericCents)) return "";
      const value = numericCents / 100;
      const hasDecimals = Math.round(numericCents) % 100 !== 0;

      try {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency,
          minimumFractionDigits: hasDecimals ? 2 : 0,
          maximumFractionDigits: 2
        }).format(value);
      } catch (_) {
        return `${value.toFixed(hasDecimals ? 2 : 0)} ${currency}`;
      }
    };

    const variantsForSize = (sizeValue) => {
      const requestedSize = normalizeSize(sizeValue);
      return variants.filter((variant) => {
        const optionValue = Array.isArray(variant.options) ? variant.options[sizeOptionIndex] : "";
        return normalizeSize(optionValue) === requestedSize;
      });
    };

    sizeButtons.forEach((button) => {
      const matchingVariants = variantsForSize(button.dataset.sizeValue);
      const availableVariant = matchingVariants.find((variant) => Boolean(variant.available));
      const unavailable = matchingVariants.length === 0 || !availableVariant;

      button.disabled = unavailable;
      button.classList.toggle("is-unavailable", unavailable);
      button.setAttribute("aria-disabled", unavailable ? "true" : "false");

      button.addEventListener("click", () => {
        if (!desktopMedia.matches || button.disabled || !availableVariant) return;

        sizeButtons.forEach((otherButton) => {
          const selected = otherButton === button;
          otherButton.classList.toggle("is-selected", selected);
          otherButton.setAttribute("aria-pressed", selected ? "true" : "false");
        });

        variantInput.value = String(availableVariant.id);
        submitButton.disabled = false;
        submitButton.textContent = "Ajouter au panier";
        if (priceValue) priceValue.textContent = formatMoney(availableVariant.price);
        if (status) status.textContent = `Taille ${button.dataset.sizeLabel || button.dataset.sizeValue} sélectionnée.`;
      });
    });

    if (desktopMedia.matches) {
      sizeButtons.find((button) => !button.disabled)?.click();
    }

    form.addEventListener("submit", (event) => {
      if (!desktopMedia.matches) return;
      if (!variantInput.value || submitButton.disabled) {
        event.preventDefault();
        if (status) status.textContent = "Choisissez une taille disponible.";
        sizeButtons.find((button) => !button.disabled)?.focus();
      }
    });
  };

  const initializeAllDesktopProducts = (scope = document) => {
    scope.querySelectorAll("[data-desktop-product]").forEach(initializeDesktopProduct);
  };

  initializeAllDesktopProducts();
  document.addEventListener("shopify:section:load", (event) => initializeAllDesktopProducts(event.target));
})();

/* Password page — random two-layer SVG crossfade for mobile and desktop. */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new WeakMap();

  const loadSource = (image, source) => new Promise((resolve, reject) => {
    const onLoad = async () => {
      cleanup();
      try {
        if (typeof image.decode === 'function') await image.decode();
      } catch (_) {
        // Loaded SVGs can still render correctly when decode() rejects.
      }
      resolve();
    };
    const onError = () => {
      cleanup();
      reject(new Error(`Unable to load ${source}`));
    };
    const cleanup = () => {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
    };

    image.addEventListener('load', onLoad, { once: true });
    image.addEventListener('error', onError, { once: true });
    image.src = source;
    if (image.complete && image.naturalWidth > 0) onLoad();
  });

  const initialize = (rotator) => {
    if (!rotator || instances.has(rotator)) return;

    const layers = Array.from(rotator.querySelectorAll('.password-mobile-fade__layer'));
    const sources = Array.from(rotator.querySelectorAll('[data-password-fade-src]'))
      .map((node) => node.dataset.passwordFadeSrc)
      .filter(Boolean);

    if (layers.length !== 2 || sources.length < 2) return;

    const interval = Math.max(2000, Number(rotator.dataset.passwordFadeInterval) || 4000);
    const fadeDuration = Math.max(0, Number(rotator.dataset.passwordFadeDuration) || 1500);
    rotator.style.setProperty('--password-fade-duration', `${fadeDuration}ms`);

    let activeLayer = 0;
    let currentIndex = 0;
    let timer = 0;
    let destroyed = false;
    let generation = 0;

    const canRun = () => (
      !destroyed &&
      !document.hidden &&
      rotator.getClientRects().length > 0
    );

    const chooseRandomIndex = () => {
      let nextIndex = currentIndex;
      while (nextIndex === currentIndex) {
        nextIndex = Math.floor(Math.random() * sources.length);
      }
      return nextIndex;
    };

    const schedule = () => {
      window.clearTimeout(timer);
      if (!canRun()) return;
      timer = window.setTimeout(change, interval);
    };

    const change = async () => {
      if (!canRun()) {
        schedule();
        return;
      }

      const localGeneration = ++generation;
      const nextIndex = chooseRandomIndex();
      const incomingLayer = activeLayer === 0 ? 1 : 0;
      const incoming = layers[incomingLayer];
      const outgoing = layers[activeLayer];

      incoming.classList.remove('is-visible');

      try {
        await loadSource(incoming, sources[nextIndex]);
      } catch (_) {
        if (!destroyed && localGeneration === generation) schedule();
        return;
      }

      if (destroyed || localGeneration !== generation || !canRun()) return;

      if (reducedMotion.matches) {
        outgoing.classList.remove('is-visible');
        incoming.classList.add('is-visible');
      } else {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            incoming.classList.add('is-visible');
            outgoing.classList.remove('is-visible');
          });
        });
      }

      activeLayer = incomingLayer;
      currentIndex = nextIndex;
      schedule();
    };

    const reset = () => {
      window.clearTimeout(timer);
      generation += 1;
      if (canRun()) schedule();
    };

    const destroy = () => {
      destroyed = true;
      window.clearTimeout(timer);
      generation += 1;
      document.removeEventListener('visibilitychange', reset);
      reducedMotion.removeEventListener?.('change', reset);
      instances.delete(rotator);
    };

    document.addEventListener('visibilitychange', reset);
    reducedMotion.addEventListener?.('change', reset);
    schedule();

    instances.set(rotator, { destroy });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-password-mobile-fade]').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-password-mobile-fade]').forEach((rotator) => {
      instances.get(rotator)?.destroy();
    });
  });
})();
